<template>
        <card>
            <template slot="header">
                <h3 class="card-title">Update Responsibility Form</h3>
            </template>
             <nav class="row">
                    <ol class="breadcrumb arr-right bg-breadcrum">
                        <li class="breadcrumb-item">
                            <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link to="/hr/responsibilityform">Responsibilities Record</router-link>
                        </li>
                        <li class="breadcrumb-item active">Update Responsibilities Form</li>
                    </ol>
                </nav>
            <hr style="margin-top:-10px" />
    
    
            <!-- Experience TO DO HERE -->
            <h2> {{item.fullname |capitalize}} </h2>
            <form @submit="update_responsibility_info">
                 <span v-for="resp in item.responsibility">
                        <!-- {{resp.name}}<br/> -->
                        <!-- {{resp.description}}<br/>
                        {{resp.received}}<br/>
                        {{resp.quantity}}<br/> -->
                 <div class="row">       
                   <div class="col-md-5">      
                        <div class="form-group">  
                          <b>Item Name:</b>  
                           <input v-model="resp.name" class="form-control">
                       </div>  
                       <div class="form-group"> 
                         <b>Description / Serial Number:</b>   
                            <input v-model="resp.description" class="form-control">
                        </div>  
                        <div class="form-group"> 
                                <b>Received:</b>                              
                            <input type="date"v-model="resp.received" class="form-control">
                        </div>  
                        <div class="form-group">  
                                <b>Quantity:</b> 
                           <input v-model="resp.quantity" class="form-control">
                       </div>  
                    </div>   
                    <div class="col-12">
                            <hr/>
                     </div>   
                   </div>  
                 </span> 
                  <!-- <div v-for="(res ,index) in responsibility">
                    <div class="row"> 
                         <span v-if="index === 1">
                                <input v-model="res.name" class="form-control">
                         </span>    
                    </div>    
                        <button class="btn btn-xs btn-primary"  @click.stop.prevent="new_field"><i class="fa fa-plus"></i></button>
                        <button @click.stop.prevent="remove_field(index)" class="btn btn-xs btn-primary"><i class="fa fa-minus"></i></button>
                  </div> -->
                
                <button class="btn btn-info"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
                <br/>
                <br/>
            </form>
        </card>
    </template>
<script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'                   
    export default {
    components: {
        Card
    },
    data(){
        return{
          item:'',
           responsibility:[
               {
                   name:'',
                   description:'',
                   received:'',
                   quantity:''
               }
           ]

        }
      },
      mounted: function() {
         this.getEmployeeResponsibility()
      },
      methods:{
           new_field(){
                this.responsibility.push({
                    name:'',
                    description:'',
                    received:'',
                    quantity:''  
                })
           },

            remove_field: function (index) {
                console.log(index);
                console.log(this.finds);
                this.responsibility.splice(index, 1);
                if (index === 0)
                    this.add_form()
            },
 
            getEmployeeResponsibility(){   
                axios.get('api/responsibilitymodify/get/' + this.$route.params.id)  
                .then(response => { this.item = response.data; })
                .catch(error => {  console.log(error) });
            },

            update_responsibility_info(e){
                e.preventDefault();
                this.$swal({
                    title: 'Are you sure?',
                    text: 'Do you want to save changes.',
                    type: 'warning',
                    showCancelButton: true,
                    showCloseButton: false,
                    })
                    .then((isConfirm) => {
                        if (isConfirm === true) {
                                axios.post('api/responsibility/update/' + this.item.id, {
                                    //Update responsibilities
                                    responsibility: this.item.responsibility,
                                    })
                                    .then(response => {
                                    this.$swal({
                                        type: 'success',
                                        title: 'Save',
                                        text: 'You successfully save changes',
                                        showConfirmButton: false,
                                        timer: 2000
                                    })

                                    this.$router.push({
                                        name: 'responsibility-form'
                                    });
                                    console.log(response.data)
                                    })
                                    .catch(e => {
                                    console.log(e.response)
                                    })
                            }
                    });
                }
      },

    }
</script>
<style>
      .m-right{
            margin:0px !important;
            padding-right: 0px!important;
        }

         .custom-button-width {
             width: 100%;
            margin-right:2px;
        }
        .bg-breadcrum{
            background:#fff;
         }
         .p-text{
            color:#666;
        }
        .text-right{
           float: right;
           margin-top:7px; 
        } 
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/todo-edit-responsibility.vue